import { addSize } from '@/core/responsive/image/responsiveImage.service';

addSize(320);
addSize(640);
addSize(1024);
addSize(1440);
